/* A body turns no faster than the first, eases into the way it is turning to at the second for
   each radian still to go, and finishes at no less than the third: radians a second. */
const TURN = { fastest: Math.PI, easing: 6, slowest: 0.5 } as const;

/** Bound visible body rotation without moving a citizen off their cleared street route. */
export function turnHeading(from: number, to: number, dt: number): number {
  const delta = Math.atan2(Math.sin(to - from), Math.cos(to - from));
  const rate = Math.min(TURN.fastest, Math.max(TURN.slowest, Math.abs(delta) * TURN.easing));
  const step = rate * Math.max(0, Math.min(0.1, dt));
  return from + Math.max(-step, Math.min(step, delta));
}

/** Residents retain their heading by identity even when the visible crowd changes order. */
export function createHeadings(count: number) {
  const headings = new Float64Array(count);
  const seen = new Int32Array(count).fill(-1);
  let frame = 0;
  let previous: number | undefined;
  let dt = 0;
  return {
    begin(seconds: number): void {
      dt = previous === undefined ? 0 : seconds - previous;
      previous = seconds;
      frame++;
    },
    at(id: number, target: number): number {
      const heading = seen[id] === frame - 1 ? turnHeading(headings[id]!, target, dt) : target;
      seen[id] = frame;
      headings[id] = heading;
      return heading;
    },
  };
}
